/// <reference path="../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import Dispatcher from '../dispatcher';
import { TranscribingActionTypes } from '../common/enums/transcribingEnums';
import { TranscriptionRoutePathNames } from '../routes';
import { RecordingActionTypes } from  '../common/enums/recordingEnums';
import { LogError } from '../../utils/ErrorTelemetry';
import { LogEventNames } from '../../backend/interfaces/ITelemetryLogger';
import { LogEvents } from '../../utils/LogEvents';
import { RenderToPaneKeys } from '../common/telemetry/RenderToPaneKeys';
import { DurationMeasureType } from '../../backend/interfaces/ILogEvent';
import { ErrorStringFromException } from '../../utils/utils';
import {TranscriptionTelemetryErrorCodes} from '../../utils/TranscriptionTelemetryErrorCodes';
import {ITranscriptionErrorEvent} from '../../backend/interfaces/ITranscriptionErrorEvent';
import { FailureActionTypes, FailureContinuation } from '../common/enums/failureEnums';
import { LoadingActionTypes } from '../common/enums/loadingEnums';
import {SetFailureContinuation, SetFailureReason} from '../common/actions/FailureActions'

export function SetFailureStateAndRouteToFailure(failureArea: LogEventNames, transcriptionErrorEvent : ITranscriptionErrorEvent, continuation: FailureContinuation, history: any) {
  LogError(failureArea, transcriptionErrorEvent.errorEventName);

  // Only navigate to failure page is we aren't already there
  if (history.location.pathname != TranscriptionRoutePathNames.Failure) {
    SetFailureContinuation(continuation);
    SetFailureReason(transcriptionErrorEvent.errorEventMessage);
    history.push(TranscriptionRoutePathNames.Failure);
  }
}

export function RevertAllStates() {
  Dispatcher.dispatch({
    type: LoadingActionTypes.RevertStateAction
  });
  Dispatcher.dispatch({
    type: TranscribingActionTypes.RevertStateAction
  });
  Dispatcher.dispatch({
    type: FailureActionTypes.RevertStateAction
  });
  Dispatcher.dispatch({
    type: RecordingActionTypes.RevertStateAction
  });
}

export async function RetryClicked(history: any) {
  try {
    LogEvents.RenderToPane.Start([{ key: RenderToPaneKeys.TriggerReason, value: "Failure page retry button clicked"}]);
    LogEvents.RenderToPane.BeginDurationMeasure(DurationMeasureType.Normal, RenderToPaneKeys.DurationSecs);

    RevertAllStates();
    history.replace(TranscriptionRoutePathNames.Loading);
  } catch(error) {
    LogEvents.RenderToPane.End([{ key: RenderToPaneKeys.RenderedSuccessfully, value: false }, { key: RenderToPaneKeys.RenderFailureReason, value: "Failure retry failed. " + ErrorStringFromException(error) }]);
    const transcriptionErrorEvent : ITranscriptionErrorEvent = {errorEventMessage : TranscriptionStrings.UnknownInitFailureReason, errorEventName: TranscriptionTelemetryErrorCodes.UnknownInitFailureReason};
    SetFailureStateAndRouteToFailure(LogEventNames.RenderToPane, transcriptionErrorEvent, FailureContinuation.None /*failureContinuation*/, history);
  }
};

export function RouteToFailureOnAuthPopupFailure(history: any) {
  const transcriptionErrorEvent : ITranscriptionErrorEvent = {errorEventMessage : TranscriptionStrings.AuthenticationLoadingFailureReason, errorEventName: TranscriptionTelemetryErrorCodes.AuthenticationLoadingFailureReason};
  SetFailureStateAndRouteToFailure(LogEventNames.ServiceAuthentication, transcriptionErrorEvent, FailureContinuation.None, history);
}